__turbopack_context__.v({
  "coral": "Wzi7zW_coral",
  "coral_midnight": "Wzi7zW_coral_midnight",
  "genre": "Wzi7zW_genre",
  "green": "Wzi7zW_green",
  "live": "Wzi7zW_live",
  "passport": "Wzi7zW_passport",
  "passport_outline": "Wzi7zW_passport_outline",
  "rating": "Wzi7zW_rating",
  "red": "Wzi7zW_red",
  "red_outline": "Wzi7zW_red_outline",
  "teal": "Wzi7zW_teal",
  "teal_midnight": "Wzi7zW_teal_midnight",
  "teal_outline": "Wzi7zW_teal_outline",
  "yellow": "Wzi7zW_yellow",
  "yellow_darken": "Wzi7zW_yellow_darken",
  "yellow_outline": "Wzi7zW_yellow_outline",
});
